import { useFilter } from "../../../../hooks/useFilter";
import { useEffect, useMemo, useState } from "react";
import "../styles.css"

export function InfoCarbon() {
    const {
        snapshot
    } = useFilter();
    const [mapByBatches, setMapByBatches] = useState(new Map());
    const [mapByMicroArea, setMapByMicroArea] = useState(new Map());

    useEffect(() => {
        if (snapshot) {
            const byBatchMap = new Map<string, any[]>();
            const byMicroAreaMap = new Map<string, any[]>();

            snapshot.forEach((item) => {
                const batchKey = item.batch_initials;
                const microAreaKey = item.micro_area_initials;

                const batchEntry = {
                    date: item.snapshot_date,
                    initials: `${item.farm_initials}-${item.area_initials}-${item.batch_initials}`,
                    days: item.supplement_offer_days,
                    total_category: item.total_from_category,
                    total_methane_emission_kg_day: item.total_methane_emission_kg_day,
                    co2_equivalent_kg: item.co2_equivalent_kg,
                };

                const microAreaEntry = {
                    date: item.snapshot_date,
                    initials: `${item.farm_initials}-${item.area_initials}-${item.micro_area_initials}`,
                    days: item.supplement_offer_days,
                    acreage: item.micro_area_acreage,
                    area_ms_intake_kg_ha: item.area_ms_intake_kg_ha,
                    total_methane_emission_kg_day: item.total_methane_emission_kg_day,
                    co2_equivalent_kg: item.co2_equivalent_kg,
                };

                if (batchKey) {
                    const batchArr = byBatchMap.get(batchKey);
                    if (batchArr) batchArr.push(batchEntry);
                    else byBatchMap.set(batchKey, [batchEntry]);
                }

                if (microAreaKey) {
                    const microArr = byMicroAreaMap.get(microAreaKey);
                    if (microArr) microArr.push(microAreaEntry);
                    else byMicroAreaMap.set(microAreaKey, [microAreaEntry]);
                }
            })

            setMapByMicroArea(byMicroAreaMap);
            setMapByBatches(byBatchMap);
        }
    }, [snapshot]);

    const fmt = (value: number) =>
        Number.isFinite(value) ? value.toLocaleString("pt-BR", { maximumFractionDigits: 2 }) : "0";

    return (
        <section className="dashBoardInfo__container" style={{ marginTop: 30 }}>
            {(() => {
                const batches = Array.from(mapByBatches.values());
                const totalCo2 = batches
                    .map((row: any[], index: number) => {
                        if (!row || row.length === 0) return null;
                        const totalCo2 = Number(row[row.length - 1]?.co2_equivalent_kg ?? 0);
                        const animals = Number(row[row.length - 1]?.total_category ?? 0);
                        const co2PerAnimal = animals > 0 ? totalCo2 / animals : 0;


                        return co2PerAnimal
                    })

                return <div className="dashBoardInfoSplited__owner--container">
                    <small>Média de Emissão por animal (kg CO2 eq/cab)</small>
                    <h6 className={"dashBoardAdjustment__positive"}>{
                        fmt(totalCo2.reduce((acc: number, cur) => acc + (cur ?? 0), 0) / totalCo2.length)
                    }</h6>
                </div>
            })()}

            {(() => {
                const microAreas = Array.from(mapByMicroArea.values());
                const totalCo2 = microAreas.map((row: any[], index: number) => {
                    if (!row || row.length === 0) return null;

                    const totalCo2 = Number(row[row.length - 1]?.co2_equivalent_kg ?? 0);
                    const area = Number(row[row.length - 1]?.acreage ?? 0);
                    const co2PerHa = area > 0 ? totalCo2 / area : 0;

                    return co2PerHa
                })

                return <div className="dashBoardInfoSplited__owner--container">
                    <small>Média de Emissão por área (kg CO2 eq/ha)</small>
                    <h6 className={"dashBoardAdjustment__positive"}>{
                        fmt(totalCo2.reduce((acc: number, cur) => acc + (cur ?? 0), 0) / totalCo2.length)
                    }</h6>
                </div>
            })()}

        </section >
    );
}